import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = ['Residential & Commercial Junk Removal', 'Garage Cleaning & Organization', 'Upfront Pricing - No Hidden Fees', 'Same-Day & Next-Day Service'];
  return <section className="relative py-20 md:py-28 bg-[#0a0f1a]" data-id="element-228">
      <div className="container mx-auto px-4" data-id="element-229">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-230">
          {/* Left: Team Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-231">
            <div className="relative rounded-2xl overflow-hidden" data-id="element-232">
              {/* Green glow effect */}
              <div className="absolute inset-0 bg-lime/20 blur-2xl scale-110" data-id="element-233" />

              {/* Placeholder image - replace with actual team photo */}
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden border-2 border-lime/30" data-id="element-234">
                <img src="https://cdn.magicpatterns.com/uploads/bUqXNxmsE9132hubarqopZ/AZ-junk-nerds-about.jpg" alt="AZ Junk Nerds team member with truck" className="w-full h-full object-cover" data-id="element-235" />
              </div>
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6 md:space-y-8" data-id="element-236">
            {/* Eyebrow */}
            <div className="inline-block px-4 py-2 bg-lime/10 border border-lime/30 rounded-full" data-id="element-237">
              <span className="text-lime font-bold text-sm tracking-wider uppercase" data-id="element-238">
                Why Choose the Nerds
              </span>
            </div>

            {/* Headline */}
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white tracking-wide leading-tight" data-id="element-239">
              WE'RE NOT YOUR{' '}
              <span className="text-lime" data-id="element-240">AVERAGE JUNK GUYS.</span>
            </h2>

            {/* Body Paragraph */}
            <p className="text-lg text-white/80 leading-relaxed" data-id="element-241">
              AZ Junk Nerds was built on one idea. Junk removal should be easy,
              transparent, and actually pleasant. No vague quotes. No
              last-minute surprises. No beat-up trucks rolling up to your house.
              We show up on time, in clean trucks, with a crew that treats your
              property like their own. Then we haul it off responsibly, donating
              and recycling whatever we can.
            </p>

            {/* Benefits List */}
            <div className="grid sm:grid-cols-2 gap-4 pt-4" data-id="element-242">
              {benefits.map((benefit, index) => <motion.div key={benefit} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-243">
                  <CheckCircle2 className="w-6 h-6 text-lime flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-244" />
                  <span className="text-white/90 font-medium leading-relaxed" data-id="element-245">
                    {benefit}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}